<template>
  <span class="logo" v-show="display" :style="logoStyle"></span>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    }
  },
  computed: {
    display () {
      return this.name !== null
    },
    logoStyle () {
      if (this.url === null) {
        return ''
      }

      return 'background-image: url(' + this.url + ');'
    }
  }
}
</script>

<style scoped>
  .logo {
    height: 50px;
    margin: auto;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
</style>
